import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { RootStoreContext } from "./store";

// import CompanyIntro from "./pages/CompanyIntro/CompanyIntro";

import Explore_1 from "./pages/explore/Explore_1";
import Explore_2_1 from "./pages/explore/Explore_2_1";
import Explore_2_2 from "./pages/explore/Explore_2_2";
import Explore_2_3 from "./pages/explore/Explore_2_3";
import Explore_3_1 from "./pages/explore/Explore_3_1";
import Explore_3_2 from "./pages/explore/Explore_3_2";
import Explore_3_3 from "./pages/explore/Explore_3_3";
import Explore4 from "./pages/explore/Explore_4";
import Milestone from "./pages/Milestone";
import MilestoneDetail from "./pages/MilestoneDetail";

import Personal from "./pages/personal/Personal";
import Personal_show from "./pages/personal/Personal_show";
import Team_list from "./pages/team/team_list";
import Team_my from "./pages/team/team_my";
import Team_up from "./pages/team/team_up";

// import milestone from "./pages/Milestone/milestone_mainpage";
// import MarketPage from "./pages/Milestone/lecture/MarketPage";
import Conclusion from "./pages/Milestone/lecture/Conclusion";
import FundraisingPage from "./pages/Milestone/lecture/FundRaisingpage";
import InvestorPage from "./pages/Milestone/lecture/Investorpage";
import LeanCanvaspage from "./pages/Milestone/lecture/LeanCanvasPage";
import Marketingpage from "./pages/Milestone/lecture/Marketingpage";
import StockPage from "./pages/Milestone/lecture/Stockpage";

import IdeaPool from "./pages/IdealPool/IdealPool";

import MainNevigation from "./components/layout/MainNevigation";
import Loading from "./pages/Loading";
import MainPage from "./pages/MainPage";
import MainPagelogin from "./pages/MainPage_login";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import style from "./App.module.css";
import CompanyIntro from "./pages/CompanyIntro/CompanyIntro";
import Home from "./pages/CompanyIntro/CompanyIntroHome";
import CompanyIntroNew from "./pages/CompanyIntro/CompanyIntroNew";

function App() {
  const { LoginStore } = useContext(RootStoreContext);
  const { login, updateData } = LoginStore;
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        updateData("user", user);
        updateData("login", true);
      } else {
        // signInWithGoogle();
        updateData("login", false);
      }
    });
  });
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isSlowConnection, setIsSlowConnection] = useState(false);
  useEffect(() => {
    function handleOnlineStatusChange() {
      setIsOnline(navigator.onLine);
    }

    window.addEventListener("online", handleOnlineStatusChange);
    window.addEventListener("offline", handleOnlineStatusChange);

    return () => {
      window.removeEventListener("online", handleOnlineStatusChange);
      window.removeEventListener("offline", handleOnlineStatusChange);
    };
  }, []);
  // useEffect(() => {
  //   if (navigator.onLine) {
  //     const connection = window.navigator.connection;
  //     const connectionSpeed = connection.downlink;

  //     if (connectionSpeed < 5) {
  //       setIsSlowConnection(true);
  //     }
  //   }
  // }, []);
  // !isOnline || isSlowConnection
  if (false) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50%",
        }}
      >
        <p>
          Sorry, it looks like your connection is slow or unavailable.
          <br />
          Please check your connection and try again.
        </p>
      </div>
    );
  }
  return (
    <>
      <div className={style.container}>
        <div>
          <MainNevigation />
        </div>
        <div className={style.body}>
          <Route
            exact
            path="/"
            render={() => {
              if (login === null) {
                return <Loading />;
              }
              return login ? <MainPagelogin /> : <MainPage />;
            }}
          />
          <Route path="/ideapool" component={IdeaPool} exact />
          <Switch>
            <Route path="/explore-1" component={Explore_1} exact />
            <Route path="/explore-2-1" component={Explore_2_1} exact />
            <Route path="/explore-2-2" component={Explore_2_2} exact />
            <Route path="/explore-2-3" component={Explore_2_3} exact />
            <Route path="/explore-3-1" component={Explore_3_1} exact />
            <Route path="/explore-3-2" component={Explore_3_2} exact />
            <Route path="/explore-3-3" component={Explore_3_3} exact />
            <Route
              exact
              path="/explore-4"
              render={() => {
                if (login === null) {
                  return <Loading />;
                }
                return login ? <MainPagelogin /> : <Explore4 />;
              }}
            />
          </Switch>
          {login && (
            <div>
              {/* <Route
              exact
              path="/"
              render={() => {
                return login ? <Redirect to="/main" /> : <MainPage />;
              }}
            /> */}
              {/* <Route path="/" component={MainPage} exact /> */}
              <Route path="/main" component={MainPagelogin} />
              <Switch>
                <Route path="/CompanyIntro" component={CompanyIntro} exact />
                <Route path="/WebMaking" component={CompanyIntroNew} exact />
                <Route path="/CompanyIntroHome" component={Home} exact />
              </Switch>
              <Switch>
                <Route path="/Profile" component={Personal} exact />
                <Route path="/Profile_show" component={Personal_show} exact />
              </Switch>
              <Switch>
                <Route path="/Teamformation" component={Team_list} exact />
                <Route path="/team-1" component={Team_my} exact />
                <Route path="/team-3" component={Team_up} exact />
              </Switch>
              <Switch>
                <Route path="/Milestone" component={Milestone} exact />
                <Route path="/Marketpage" component={Marketingpage} exact />
                <Route
                  path="/LeanCanvaspage"
                  component={LeanCanvaspage}
                  exact
                />
                <Route path="/Marketingpage" component={Marketingpage} exact />
                <Route path="/Stockpage" component={StockPage} exact />
                <Route path="/Investorpage" component={InvestorPage} exact />
                <Route path="/Conclusion" component={Conclusion} exact />
                <Route
                  path="/Fundraisingpage"
                  component={FundraisingPage}
                  exact
                />
                <Route
                  path="/Milestone/MilestoneDetail/:index"
                  component={MilestoneDetail}
                  exact
                />
              </Switch>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default observer(App);
